import {css} from "styled-components"
import {WorkSansLight, WorkSansMedium, WorkSansBold, WorkSansSemibold} from "../../global/fonts"
import {minWidthMedia} from "../../global/media"
import {greys, perkbox} from "../../global/colors"
import addBottomPadding, {BottomPaddingProps} from "./addBottomPadding"
import {spacingCss, SpacingProps} from "../../global/css"

const UpperCase = "text-transform: uppercase;"

export interface LabelProps extends BottomPaddingProps, SpacingProps {
  bold?: boolean,
  uppercase?: boolean,
  flush?: boolean,
  block?: boolean
}

export interface ParaProps extends SpacingProps {
  bold?: boolean,
  uppercase?: boolean,
  flush?: boolean,
  light?: boolean,
  blue?: boolean,
  large?: boolean,
  center?: boolean,
  narrow?: boolean,
  display?: string
}

// Used for large buttons
export const label1 = css<LabelProps>`
  ${WorkSansMedium}
  ${({display}) => display && `display: ${display};`}
  ${(props) => props.bold !== false && WorkSansBold}
  ${(props) => (props.uppercase !== false ? `${UpperCase}` : "")}
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.2px;
  ${(props) => addBottomPadding(props)};

  ${minWidthMedia.tablet`
    font-size: 14px;
  `}
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}
  ${({block}) => block && "display: block;"}
`

export const label2 = css<LabelProps>`
  ${WorkSansMedium}
  ${(props) => props.bold && WorkSansBold}
  ${(props) => (props.uppercase ? `${UpperCase}` : "")}
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.4px;
  ${(props) => addBottomPadding(props)};
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}
  ${({block}) => block && "display: block;"}
`

export const label3 = css<LabelProps>`
  ${WorkSansMedium}
  ${(props) => props.bold && WorkSansBold}
  ${(props) => (props.uppercase ? `${UpperCase}` : "")}
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.6px;
  ${(props) => addBottomPadding(props)};
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}
  ${({block}) => block && "display: block;"}
`

export const label4 = css<LabelProps>`
  ${WorkSansMedium}
  ${(props) => props.bold && WorkSansBold}
  ${UpperCase}
  font-size: 8px;
  line-height: 12px;
  letter-spacing: 1px;
  ${(props) => addBottomPadding(props)};
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}
`

export const caption = css<LabelProps>`
  ${WorkSansSemibold}
  ${(props) => props.bold && WorkSansBold}
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 10px;
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}
  ${minWidthMedia.desktop`
    ${WorkSansMedium}
  `}
`

export const smallCaption = css<LabelProps>`
  ${WorkSansMedium}
  ${(props) => props.bold && WorkSansBold}
  ${(props) => (props.uppercase ? `${UpperCase}` : "")}
  color: ${greys.mediumDark};
  font-size: 8px;
  line-height: 12px;
  letter-spacing: 0.6px;
  ${spacingCss}
  ${minWidthMedia.tablet`
    font-size: 10px;
  `}
`

export const para = css<ParaProps>`
  ${WorkSansMedium}
  ${({bold}) => bold && WorkSansBold}
  ${({light}) => light && WorkSansLight}
  ${({blue}) => blue && `color: ${perkbox.blue};`}

  margin-bottom: 10px;
  ${spacingCss}
  ${({flush}) => flush && "margin-bottom: 0;"}

  font-size: 12px;
  ${({large}) => large && "font-size: 14px;"}

  text-align: ${({center}) => (center ? "center" : "initial")};
  ${({uppercase}) => uppercase && UpperCase}

  line-height: 18px;
  letter-spacing: 0.4px;
  ${minWidthMedia.tablet`
    font-size: 14px;
    ${({large}) => large && "font-size: 18px;"}
    line-height: ${({narrow, large}) => (narrow || large ? "23px;" : "18px;")}
    letter-spacing: 0.2px;
  `}
`
